<template>
    <div>
        <vx-card title="" no-shadow card-border id="" class="mt-base">
            <div class="flex items-end">
                <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Ubicación del Proyecto</span>
            </div>

            <vs-divider/>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">CODIGO UNICO</label>
                    <div class="w-full mb-2 vx-col md:w-1/2">
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputCUI" v-validate="'required|numeric'" name="codigo" placeholder="Codigo único o SNIP"/>
                        <span class="text-sm text-danger" v-show="errors.has('codigo')">{{ errors.first('codigo') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full vx-col">
                <label class="ml-2 text-sm opacity-100">Nombre de la Inversión</label>
                <div class="w-full vx-col">
                    <vs-textarea class="w-full" v-model="inputNombreInversion" v-validate="'required'" name="nombre" placeholder="Ingrese nombre de la Inversión"/>
                    <span class="text-sm text-danger" v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Longitud</label>
                    <vs-input class="w-full" v-model="inputLongitud" v-validate="'required'" name="longitud" placeholder="Ingrese longitud"/>
                    <span class="text-sm text-danger" v-show="errors.has('longitud')">{{ errors.first('longitud') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">Latitud</label>
                    <vs-input class="w-full" v-model="inputLatitud" v-validate="'required'" name="codigo" placeholder="Ingrese latitud"/>
                    <span class="text-sm text-danger" v-show="errors.has('latitud')">{{ errors.first('codigo') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <label class="ml-2 text-sm opacity-100">Departamento</label>
                    <vs-input class="w-full" v-model="inputDepartamento" v-validate="'required'" name="departamento" placeholder="Ingrese el Departamento"/>
                    <span class="text-sm text-danger" v-show="errors.has('departamento')">{{ errors.first('departamento') }}</span>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Provincia</label>
                        <v-select :options="itemsProvincia" v-model="selectedProvincia" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="cargo">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('provincia')">{{ errors.first('provincia') }}</span>
                    </div>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Distrito</label>
                        <v-select :options="itemsDistrito" v-model="selectedDistrito" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="cargo">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('distrito')">{{ errors.first('distrito') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full mt-2 vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button @click="guardar" icon-pack="feather" color="primary" icon="icon-save" class="mt-2 ml-auto">Guardar</vs-button>
                    <vs-button @click="regresar" icon-pack="feather" color="warning" icon="icon-rotate-ccw" class="mt-2 ml-4">Regresar</vs-button>
                    <vs-button @click="limpiar" icon-pack="feather" color="danger" type="border" icon="icon-trash"  class="mt-2 ml-4">Limpiar</vs-button>
                </div>
            </div>

        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
    components: {
        'v-select': vSelect
    },

    data(){
        return {
            parametro               : null,

            inputCUI                : null,
            inputNombreInversion    : null,
            inputLongitud           : null,
            inputLatitud            : null,
            inputDepartamento       : 'Cusco',
            selectedProvincia       : null,
            selectedDistrito        : null,
            
            itemsDepartamento       : [],
            itemsProvincia          : [],
            itemsDistrito           : [],
        }
    },

    created(){
        this.parametro = this.$route.params.id;
    },

    mounted(){
        this.listarProvincia();
        this.getProyecto(this.parametro);
    },

    watch: {
        selectedProvincia(val){
            if(val.value === '') {
                this.selectedDistrito = null;
                this.itemsDistrito = [];
            } else {
                this.listarDistrito(val.value);
            }
        },
    },

    methods: {
        listarProvincia(){
            this.$vs.loading();
            this.$http.listarProvincia()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsProvincia = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarDistrito(id){
            this.$vs.loading();
            this.$http.listarDistritoPorProvincia(id)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsDistrito = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getProyecto(value){
            this.$vs.loading();
            this.$http.fetchUbicacion(value)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.loadData(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        loadData(data){
            this.inputCUI               = data.cui;
            this.inputNombreInversion   = data.nombre;
            this.inputLongitud          = data.x;
            this.inputLatitud           = data.y;
            this.selectedProvincia      = data.provincia === null ? null : { value: data.provincia.id, label: data.provincia.descripcion };
            this.selectedDistrito       = data.distrito === null ? null : { value: data.distrito.id, label: data.distrito.descripcion };
        },

        guardar(){
            if(this.inputCUI === null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'warning',
                    title: `Aviso`,
                    text: 'El campo de CUI del PIP es obligatorio',
                    acceptText: 'Aceptar',
                });
                return;
            }
            const payload = {
                cui: this.inputCUI,
                data: {
                    cui: this.inputCUI,
                    x: this.inputLongitud,
                    y: this.inputLatitud,
                    provincia: this.selectedProvincia.value,
                    distrito: this.selectedDistrito.value
                }
            };

            this.$vs.loading();
            this.$http.updateUbicacion(payload)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.regresar();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        limpiar(){},

        regresar(){
            this.$router.push({
				name: 'app-parametro-proyecto'
			}).catch(() => {});
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>